module.exports = __webpack_public_path__ + "img/arcade_med.1613dc71.webp";